// @flow

import React, { type Node, useEffect, useRef, useState } from 'react';
import { InputMask } from '@tectonics/components/input-mask';
import styled from 'styled-components';

const otpSixDigitsCodeSize = 6;

export function OtpInputWithValidation(): Node {
  const [otp, setOtp] = useState(new Array(otpSixDigitsCodeSize).fill(''));
  const otpBoxReference = useRef([]);

  function handleChange(value, index) {
    let newArr = [...otp];
    newArr[index] = value;
    setOtp(newArr);

    if(value && index < otpSixDigitsCodeSize-1 && otpBoxReference.current){
      const nextInput = otpBoxReference.current[index + 1];
      if (nextInput) {
        nextInput.focus();
      }
    }
  }

  function handleBackspaceAndEnter(e, index) {
    if(e.key === 'Backspace' && !e.target.value && index > 0){
      const nextInput = otpBoxReference.current[index - 1];
      if (nextInput) {
        nextInput.focus();
      }
    }
    if(e.key === 'Enter' && e.target.value && index < otpSixDigitsCodeSize-1){
      const nextInput = otpBoxReference.current[index + 1];
      if (nextInput) {
        nextInput.focus();
      }
    }
  }

  function handleNumberDigits(e) {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  }

  useEffect(()=> {
    const nextInput = otpBoxReference.current[0];
    if (nextInput) {
      nextInput.focus();
    }
  }, []);

  return(
    <InputCode>
      {otp.map((digit, index)=>(
        <InputBox key={index} value={digit} maxLength={1}
          as={InputMask}
          type="tel"
          mask={SIX_NUMBER_PATTERN}
          onChange={(e)=> handleChange(e.target.value, index)}
          onKeyUp={(e)=> handleBackspaceAndEnter(e, index)}
          onKeyPress={(e) => handleNumberDigits(e)}
          ref={(reference) => (otpBoxReference.current[index] = reference)}
          name="customer-otp-code"
          data-test-id={`customer-otp-code-${index}`}
          placeholder="*"
        />
      ))}
    </InputCode>
  );
}

const InputBox = styled.input`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 12px;
  gap: 8px;
  width: 40px;
  height: 50px;
  background: #ffffff;
  border: 1px solid #d4d9e3;
  border-radius: 4px;
  text-align: center;
`;

const InputCode = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;
  gap: 12px;

  width: 300px;
  height: 50px;
  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 24px 0 24px 0;
`;

const SIX_NUMBER_PATTERN = [
  /[0-9]/, /[0-9]/, /[0-9]/,
  /[0-9]/, /[0-9]/, /[0-9]/,
];
